import { render, staticRenderFns } from "./OverviewDocs.vue?vue&type=template&id=79661520&scoped=true&"
import script from "./OverviewDocs.vue?vue&type=script&lang=ts&"
export * from "./OverviewDocs.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewDocs.vue?vue&type=style&index=0&id=79661520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79661520",
  null
  
)

export default component.exports